import EntryForm from "@app/components/forms/entry-form.tsx";
import { PageContainer } from "@app/components/page-container.tsx";
import useCategoryData from "@app/data-hooks/use-category-data.ts";
import { createFileRoute } from "@tanstack/react-router";

interface SearchParams {
    catId: number;
    from: string;
}

export const Route = createFileRoute("/_authenticated/entry/create")({
    component: RouteComponent,
    validateSearch: (search: Record<string, unknown>): SearchParams => {
        return {
            catId: search.catId as number,
            from: search.from as string,
        };
    },
});

function RouteComponent() {
    const { catId, from } = Route.useSearch();

    const { categories } = useCategoryData({ entryCategoryId: catId });

    return (
        <PageContainer
            title={`Create ${categories.data?.find((x) => x.categoryId == catId)?.categoryDescription}`}
            from={from}
        >
            <EntryForm catId={catId} from={from} />
        </PageContainer>
    );
}
